<template>
  <div>
    <div class='favorites-section__topic'>
      <div class='favorites-section__topic-quantity'>{{ properties.length || 0 }} {{ locales && locales.common && locales.common.properties }}</div>
      <div class='theme-order-select ml-auto pl-2.5'>
        <select class='theme-order-select__item' name='order' @change='sort'>
          <option value='published_at_desc' :selected="order === 'published_at_desc'">
                {{ locales && locales.common && locales.common.most_recent }}
              </option>
              <option value='published_at_asc' :selected="order === 'published_at_asc'">
                {{ locales && locales.common && locales.common.oldest_first }}
              </option>
              <option value='location_asc' :selected="order === 'location_asc'">
                {{ locales && locales.common && locales.common.location_a_z }}
              </option>
              <option value='location_desc' :selected="order === 'location_desc'">
                {{ locales && locales.common && locales.common.location_z_a }}
              </option>
        </select>
      </div>
    </div>
    <div class='favorites-section__list'>
      <div v-for='property in properties' class='favorites-section__list-item grid-cols-12 items-center gap-2 lg:grid'>
        <div class='col-span-1 mb-3 lg:mb-0'>
          <img class='favorites-section__list-item-image js-protected-property-photo' draggable='false' :src='property.listingMainPhoto' alt='image'>
        </div>
        <div class='col-span-5 grid grid-cols-12 items-center lg:pr-5 mb-3 lg:mb-0'>
          <div class='col-span-9 pr-5'>
            <h4 class='favorites-section__list-item-name'>{{ property.listingAddress }}</h4>
            <div class='favorites-section__list-item-note'>{{ property.fullAddress }}</div>
          </div>
          <div class='col-span-3 text-right lg:text-left'>
            <template v-if='!isStaffHousing && property.show_price == 1'>
              <div class='mb-2'>€ {{
                  property.ah_price && property.ah_price.indexOf(',00') == -1 ? (property.ah_price.indexOf(',') != -1 ? property.ah_price : property.ah_price + ',-') : (property.ah_price ? property.ah_price.replace(',00', ',-') : '')
                }}
              </div>
              <div class='favorites-section__list-item-note'>
                {{ locales.properties && locales.properties.a_month }}
                <span v-html='property.ah_price_includes_short'></span>
              </div>
            </template>
            <template v-else-if='!isStaffHousing'>
              {{ locales.properties && locales.properties.price_on_request }}
            </template>
            <template v-else>
              {{ property.max_people }} {{ locales.properties && locales.properties.max_number_of_persons }}
            </template>
          </div>
        </div>
        <div class='col-span-2 grid grid-cols-2 lg:grid-cols-1 mb-3 lg:mb-0 lg:pr-5'>
          <div class='lg:hidden'>Property type:</div>
          <div class='text-right lg:text-left'>
            <div class='mb-2'>{{ property.type && property.type.value }}</div>
            <div class='favorites-section__list-item-note'>{{ property.no_bedrooms }}
              {{ locales.properties && locales.properties.bedrooms }}
            </div>
          </div>
        </div>
        <div class='col-span-2 grid grid-cols-2 lg:grid-cols-1 mb-3 lg:mb-0 lg:pr-5'>
          <div class='lg:mb-2'>{{ locales.properties && locales.properties.available_on }}:</div>
          <div class='text-right lg:text-left'>
            <div v-if='isUnavailable(property.status)' class='favorites-section__list-item-note'>
              {{ statusText(property) }}
            </div>
            <div v-else class='favorites-section__list-item-note'>{{ property.available_on }}</div>
          </div>
        </div>
        <div class='col-span-2 flex items-center'>
          <a v-if='!isUnavailable(property.status)' :href='property.url' class='theme-btn theme-btn--small theme-btn--theme theme-btn--block lg:mr-5'>
            {{locales && locales.common && locales.common.view_details}}
            <span class='icon-thin-right text-[20px]'/>
          </a>
          <div v-if='isUnavailable(property.status)' class='favorites-section__list-item-unavailable'/>
          <span class='favorites-section__list-item-heart' @click='remove(property.id)'>
            <div class='icon-heart-filled text-[20px]'/>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import queryString from 'query-string';
  import {mapGetters} from 'vuex';
  import _ from 'lodash';
  import $ from 'jquery';

  export default {
    computed: {
      ...mapGetters(['metadata', 'locales']),
      layout() {
        return this.$store.getters.getPropertiesLayout;
      },
      properties() {
        return this.$store.getters.getPropertiesCollection;
      },
      isStaffHousing() {
        return typeof window !== 'undefined' && window.location.href.includes('staffhousing');
      }
    },
    props: {
      userId: {
        default: 0,
        type: [Number, String],
      },
      lang: {
        default: '',
        type: String,
      },
      site: {
        default: '',
        type: String,
      },
    },
    data() {
      return {
        order: queryString.parse(window.location.search).order,
      };
    },
    methods: {
      remove(id) {
        if (window.app.sweetalert) {
          window.app.sweetalert(this.locales.properties.are_you_sure_you_want_to_remove_this_favorite, {
            buttons: ['Cancel', 'Ok'],
          }).then(value => {
            if (value) {
              $.ajax({
                url: `/api/favorites/delete/${id}/${this.userId}`,
                method: 'delete',
                success: (response) => {
                  this.$store.commit('SET_PROPERTIES_COLLECTION', response);
                  this.$store.commit('SET_PROPERTIES_FAVORITES', response);
                  if (response.length < 1) {
                    $('.properties').append('<span>' + this.locales.properties.there_are_no_favorites_yet + '</span>');
                  }
                  window.app.sweetalert(this.locales.common.success, this.locales.properties.favorite_removed, 'success');
                },
                error: () => {
                  window.app.sweetalert('Oops!', 'Error deleting', 'error');
                },
              });
            }
          });
        }
      },
      isUnavailable(status) {
        return status &&
          status.attribute &&
          status.attribute.slug !== 'new' &&
          status.attribute.slug !== 'active' &&
          status.attribute.slug !== 'option' &&
          status.attribute.slug !== 'tophouse' &&
          status.attribute.slug !== 'lower_price' &&
          status.attribute.slug !== 'recommended';
      },
      // Same App\Helpers\PropertyStatusPresenter contract PropertiesListing.vue's ribbon
      // reads (property.status_presentation, already appended to this payload -
      // Property::$appendProfileListing gets set before this listing is built). Never falls
      // back to the raw status.attribute.slug - that would leak an internal metadata slug
      // (e.g. literally "rented_by_us") straight into the page.
      statusText(property) {
        var presentation = property.status_presentation;
        return (presentation && presentation.visible) ? presentation.label : 'Unavailable';
      },
      sort(event) {
        let search = queryString.parse(window.location.search);
        search.order = event.target.value;
        window.location.search = queryString.stringify(search);
      },
    },
  };
</script>